export class UsernameContainerController {
    /* @ngInject */
    constructor(passwordCredentialsService,
                authenticatedUserService,
                accountCreationHelpService,
                $stateParams,
                $state,
                $log) {
        this.passwordCredentialsService = passwordCredentialsService;
        this.authenticatedUserService = authenticatedUserService;
        this.accountCreationHelpService = accountCreationHelpService;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.$log = $log;
    }

    $onInit() {
        this.state = this.$stateParams.state;
        this.popup = this.$stateParams.popup;

        this.usernameTaken = false;

        this.edit = this.state === 'EDIT';
    }

    verifyUsername() {
        if (this.state === 'ACTIVATE') {
            this.retrieveAuthenticatedUser();
        }

        if (this.state === 'EDIT') {
            this.$state.go('flow');
        }
    }

    retrieveAuthenticatedUser() {
        this.authenticatedUserService.canActivate(this.username)
            .then((response) => {
                if (response.data.canActivate) {
                    this.$state.go('activate.email', {
                        state: this.state,
                        popup: this.popup,
                        username: this.username
                    });
                } else {
                    this.usernameTaken = true;
                }
            })
            .catch((error) => this.$log.error(error));
    }
}

export let UsernameContainerComponent = {
    controller: UsernameContainerController,
    controllerAs: 'vm',
    templateUrl: 'app/login/username/UsernameContainerComponent.html',
    bindings: {}
};
